import { pathExists } from "fs-extra";

const hasPackageJson = async () => await pathExists("package.json");

export default hasPackageJson;
